import { combineReducers } from "redux";
import { connectionReuducer } from "./connectionReducer";

const reducers = combineReducers({
    connection: connectionReuducer
});

export default reducers;

export type RootState = ReturnType<typeof reducers>;
